export enum AccountType {
    Admin = 0,
    Mod = 1,
    User = 2
}